import React, { useEffect, useState } from "react";
import { Table, Pagination } from "react-bootstrap";
import {
  FiPlus,
  FiHome,
  FiChevronRight,
  FiEdit,
} from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getfeetype } from "../../store/slices/fees";
import { toast } from "react-hot-toast";

export default function FeeCategoryList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [feeCategories, setFeeCategories] = useState([]);

  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);

  const fetchFeeCategories = () => {
    dispatch(getfeetype())
      .unwrap()
      .then((res) => {
        const data = res?.data || [];
        setFeeCategories(data);
        setTotalData(data.length);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to fetch fee categories");
        setFeeCategories([]);
      });
  };

  useEffect(() => {
    fetchFeeCategories();
  }, []);

  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const paginatedData = feeCategories.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>

            <FiChevronRight className="separator" />

            <span className="active">Fee Type</span>
          </div>

          <Link
            to="/institute/add-fee-type"
            className="add-btn"
          >
            <FiPlus />
            Add Fee Type
          </Link>
        </div>
      </div>

      <div className="staff-card">
        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>
                <th className="text-center">#</th>
                <th className="text-center">Fee Type</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    No fee categories found
                  </td>
                </tr>
              ) : (
                paginatedData.map((item, index) => (
                  <tr key={item._id}>
                    <td className="text-center">
                      {startIndex + index + 1}
                    </td>

                    <td className="text-center">
                      {item.name}
                    </td>

                    <td className="text-center">
                      <button
                        className="edit-btn"
                        onClick={() =>
                          navigate(`/institute/edit-fee-type/${item._id}`)
                        }
                      >
                        <FiEdit size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-end my-3">
          <Pagination className="mb-0">
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 &&
                  page <= currentPage + 1)
              ) {
                return (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              }

              if (page === currentPage - 2) {
                return (
                  <Pagination.Ellipsis
                    key={`left-${page}`}
                    disabled
                  />
                );
              }

              if (page === currentPage + 2) {
                return (
                  <Pagination.Ellipsis
                    key={`right-${page}`}
                    disabled
                  />
                );
              }

              return null;
            })}

            <Pagination.Next
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            />
          </Pagination>
        </div>
      </div>
    </>
  );
}